var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',_vm._g(_vm._b({staticClass:"pt-0 mt-0",attrs:{"input-value":_vm.value,"label":_vm.field.title,"rules":_vm.rules},on:{"change":function($event){return _vm.$emit('input', $event)}}},'v-checkbox',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }